// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { AssetInfoFragmentDoc } from '../../../projects/assets/AssetPreview.generated';
import { NamedFragmentDoc, DisplayNamedFragmentDoc } from '../../../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type DesignPackageProductCardPage_MaterialVariantQueryVariables = Types.Exact<{
  placeholderTliId: Types.Scalars['ID']['input'];
  materialVariantId: Types.Scalars['ID']['input'];
  skipMaterialVariant: Types.Scalars['Boolean']['input'];
  rpavId: Types.Scalars['ID']['input'];
}>;


export type DesignPackageProductCardPage_MaterialVariantQuery = { __typename?: 'Query', materialVariant?: { __typename?: 'MaterialVariant', id: string, displayName: string, modelNumber?: string | null | undefined, designFeedback?: string | null | undefined, materialAttributeValues: Array<{ __typename?: 'MaterialAttributeValue', id: string, textValue: string, dimension: { __typename?: 'MaterialAttributeDimension', id: string, name: string } }>, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, sortOrder: number, asset?: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined } | null | undefined } | null | undefined, listing: { __typename?: 'MaterialListing', id: string, name?: string | null | undefined, brand?: { __typename?: 'MaterialBrand', id: string, name: string } | null | undefined } }, takeoffLineItem: { __typename?: 'TakeoffLineItem', id: string, item: { __typename?: 'Item', id: string, name: string }, planLines: Array<{ __typename?: 'TakeoffLineItem', id: string, name: string, item: { __typename?: 'Item', id: string, fullCode: string }, location: { __typename?: 'Location', id: string, displayLocationPath: string }, readyPlan: { __typename?: 'ReadyPlan', id: string, name: string, version: { __typename?: 'ReadyPlanAggregateVersion', id: string } } | { __typename?: 'PlanPackage', id: string, name: string, version: { __typename?: 'ReadyPlanAggregateVersion', id: string } } | { __typename?: 'DesignPackage', id: string, name: string, version: { __typename?: 'ReadyPlanAggregateVersion', id: string } } | { __typename?: 'ProductOffering', id: string, name: string, version: { __typename?: 'ReadyPlanAggregateVersion', id: string } } }>, targetGroups: Array<{ __typename?: 'ReadyPlanOptionGroup', id: string }>, missingCombinations: Array<{ __typename?: 'DesignPackageOptionCombination', id: string }> } };

export type DesignPackageProductCardPage_ProductTliQueryVariables = Types.Exact<{
  productTliId: Types.Scalars['ID']['input'];
  versionId: Types.Scalars['ID']['input'];
}>;


export type DesignPackageProductCardPage_ProductTliQuery = { __typename?: 'Query', takeoffLineItem: { __typename?: 'TakeoffLineItem', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string }>, placeholder?: { __typename?: 'TakeoffLineItem', id: string, targetGroups: Array<{ __typename?: 'ReadyPlanOptionGroup', id: string }> } | null | undefined, targetCombinations: Array<{ __typename?: 'DesignPackageOptionCombination', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string }> }>, targetPlan?: { __typename?: 'PlanPackage', id: string } | null | undefined } };

export type DesignPackageProductCardPage_OptionCombinationsQueryVariables = Types.Exact<{
  placeholderCombinationsInput: Types.PlaceholderCombinationsInput;
  designPackageId: Types.Scalars['ID']['input'];
  designPackageVersionId: Types.Scalars['ID']['input'];
  targetGroupIds?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
}>;


export type DesignPackageProductCardPage_OptionCombinationsQuery = { __typename?: 'Query', designPackage: { __typename?: 'DesignPackage', id: string, combinations: Array<{ __typename?: 'DesignPackageOptionCombination', id: string, name: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string }> }> }, placeholderCombinations: Array<{ __typename?: 'PlaceholderCombinationsResult', takeoffLineItem: { __typename?: 'TakeoffLineItem', id: string }, combinations: Array<{ __typename?: 'DesignPackageOptionCombination', id: string, name: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string }> }> }> };

export type DesignPackageProductCardPage_OptionCombinationFragment = { __typename?: 'DesignPackageOptionCombination', id: string, name: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string }> };

export type DesignPackageProductCardPage_PlaceholderTliFragment = { __typename?: 'TakeoffLineItem', id: string, item: { __typename?: 'Item', id: string, name: string }, planLines: Array<{ __typename?: 'TakeoffLineItem', id: string, name: string, item: { __typename?: 'Item', id: string, fullCode: string }, location: { __typename?: 'Location', id: string, displayLocationPath: string }, readyPlan: { __typename?: 'ReadyPlan', id: string, name: string, version: { __typename?: 'ReadyPlanAggregateVersion', id: string } } | { __typename?: 'PlanPackage', id: string, name: string, version: { __typename?: 'ReadyPlanAggregateVersion', id: string } } | { __typename?: 'DesignPackage', id: string, name: string, version: { __typename?: 'ReadyPlanAggregateVersion', id: string } } | { __typename?: 'ProductOffering', id: string, name: string, version: { __typename?: 'ReadyPlanAggregateVersion', id: string } } }>, targetGroups: Array<{ __typename?: 'ReadyPlanOptionGroup', id: string }>, missingCombinations: Array<{ __typename?: 'DesignPackageOptionCombination', id: string }> };

export type DesignPackageProductCardPage_SaveTakeoffLineItemMutationVariables = Types.Exact<{
  readyPlanId: Types.Scalars['ID']['input'];
  input: Array<Types.SaveTakeoffLineItemInput> | Types.SaveTakeoffLineItemInput;
}>;


export type DesignPackageProductCardPage_SaveTakeoffLineItemMutation = { __typename?: 'Mutation', saveTakeoffLineItems: { __typename?: 'SaveTakeoffLineItemResult', version: { __typename?: 'ReadyPlanAggregateVersion', id: string, readyPlan: { __typename?: 'ReadyPlan', id: string, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined } | null | undefined } | { __typename?: 'PlanPackage', id: string, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined } | null | undefined } | { __typename?: 'DesignPackage', id: string, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined } | null | undefined } | { __typename?: 'ProductOffering', id: string, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined } | null | undefined } } } };

export const DesignPackageProductCardPage_OptionCombinationFragmentDoc = gql`
    fragment DesignPackageProductCardPage_OptionCombination on DesignPackageOptionCombination {
  id
  name
  options {
    id
  }
}
    `;
export const DesignPackageProductCardPage_PlaceholderTliFragmentDoc = gql`
    fragment DesignPackageProductCardPage_PlaceholderTli on TakeoffLineItem {
  id
  item {
    ...Named
  }
  planLines {
    ...Named
    item {
      id
      fullCode
    }
    location {
      id
      displayLocationPath
    }
    readyPlan {
      id
      name
      version {
        id
      }
    }
  }
  targetGroups {
    id
  }
  missingCombinations {
    id
  }
}
    ${NamedFragmentDoc}`;
export const DesignPackageProductCardPage_MaterialVariantDocument = gql`
    query DesignPackageProductCardPage_MaterialVariant($placeholderTliId: ID!, $materialVariantId: ID!, $skipMaterialVariant: Boolean!, $rpavId: ID!) {
  materialVariant(id: $materialVariantId) @skip(if: $skipMaterialVariant) {
    id
    displayName
    modelNumber
    designFeedback
    materialAttributeValues {
      id
      textValue
      dimension {
        id
        name
      }
    }
    featuredImage {
      id
      sortOrder
      asset {
        ...AssetInfo
      }
    }
    listing {
      id
      name
      brand {
        id
        name
      }
    }
  }
  takeoffLineItem(id: $placeholderTliId, versionId: $rpavId) {
    ...DesignPackageProductCardPage_PlaceholderTli
  }
}
    ${AssetInfoFragmentDoc}
${DesignPackageProductCardPage_PlaceholderTliFragmentDoc}`;

/**
 * __useDesignPackageProductCardPage_MaterialVariantQuery__
 *
 * To run a query within a React component, call `useDesignPackageProductCardPage_MaterialVariantQuery` and pass it any options that fit your needs.
 * When your component renders, `useDesignPackageProductCardPage_MaterialVariantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDesignPackageProductCardPage_MaterialVariantQuery({
 *   variables: {
 *      placeholderTliId: // value for 'placeholderTliId'
 *      materialVariantId: // value for 'materialVariantId'
 *      skipMaterialVariant: // value for 'skipMaterialVariant'
 *      rpavId: // value for 'rpavId'
 *   },
 * });
 */
export function useDesignPackageProductCardPage_MaterialVariantQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DesignPackageProductCardPage_MaterialVariantQuery, DesignPackageProductCardPage_MaterialVariantQueryVariables> & ({ variables: DesignPackageProductCardPage_MaterialVariantQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DesignPackageProductCardPage_MaterialVariantQuery, DesignPackageProductCardPage_MaterialVariantQueryVariables>(DesignPackageProductCardPage_MaterialVariantDocument, options);
      }
export function useDesignPackageProductCardPage_MaterialVariantLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DesignPackageProductCardPage_MaterialVariantQuery, DesignPackageProductCardPage_MaterialVariantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DesignPackageProductCardPage_MaterialVariantQuery, DesignPackageProductCardPage_MaterialVariantQueryVariables>(DesignPackageProductCardPage_MaterialVariantDocument, options);
        }
export function useDesignPackageProductCardPage_MaterialVariantSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DesignPackageProductCardPage_MaterialVariantQuery, DesignPackageProductCardPage_MaterialVariantQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DesignPackageProductCardPage_MaterialVariantQuery, DesignPackageProductCardPage_MaterialVariantQueryVariables>(DesignPackageProductCardPage_MaterialVariantDocument, options);
        }
export type DesignPackageProductCardPage_MaterialVariantQueryHookResult = ReturnType<typeof useDesignPackageProductCardPage_MaterialVariantQuery>;
export type DesignPackageProductCardPage_MaterialVariantLazyQueryHookResult = ReturnType<typeof useDesignPackageProductCardPage_MaterialVariantLazyQuery>;
export type DesignPackageProductCardPage_MaterialVariantSuspenseQueryHookResult = ReturnType<typeof useDesignPackageProductCardPage_MaterialVariantSuspenseQuery>;
export type DesignPackageProductCardPage_MaterialVariantQueryResult = Apollo.QueryResult<DesignPackageProductCardPage_MaterialVariantQuery, DesignPackageProductCardPage_MaterialVariantQueryVariables>;
export const DesignPackageProductCardPage_ProductTliDocument = gql`
    query DesignPackageProductCardPage_ProductTli($productTliId: ID!, $versionId: ID!) {
  takeoffLineItem(id: $productTliId, versionId: $versionId) {
    id
    options {
      id
    }
    placeholder {
      id
      targetGroups {
        id
      }
    }
    targetCombinations {
      id
      options {
        id
      }
    }
    targetPlan {
      id
    }
  }
}
    `;

/**
 * __useDesignPackageProductCardPage_ProductTliQuery__
 *
 * To run a query within a React component, call `useDesignPackageProductCardPage_ProductTliQuery` and pass it any options that fit your needs.
 * When your component renders, `useDesignPackageProductCardPage_ProductTliQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDesignPackageProductCardPage_ProductTliQuery({
 *   variables: {
 *      productTliId: // value for 'productTliId'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useDesignPackageProductCardPage_ProductTliQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DesignPackageProductCardPage_ProductTliQuery, DesignPackageProductCardPage_ProductTliQueryVariables> & ({ variables: DesignPackageProductCardPage_ProductTliQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DesignPackageProductCardPage_ProductTliQuery, DesignPackageProductCardPage_ProductTliQueryVariables>(DesignPackageProductCardPage_ProductTliDocument, options);
      }
export function useDesignPackageProductCardPage_ProductTliLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DesignPackageProductCardPage_ProductTliQuery, DesignPackageProductCardPage_ProductTliQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DesignPackageProductCardPage_ProductTliQuery, DesignPackageProductCardPage_ProductTliQueryVariables>(DesignPackageProductCardPage_ProductTliDocument, options);
        }
export function useDesignPackageProductCardPage_ProductTliSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DesignPackageProductCardPage_ProductTliQuery, DesignPackageProductCardPage_ProductTliQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DesignPackageProductCardPage_ProductTliQuery, DesignPackageProductCardPage_ProductTliQueryVariables>(DesignPackageProductCardPage_ProductTliDocument, options);
        }
export type DesignPackageProductCardPage_ProductTliQueryHookResult = ReturnType<typeof useDesignPackageProductCardPage_ProductTliQuery>;
export type DesignPackageProductCardPage_ProductTliLazyQueryHookResult = ReturnType<typeof useDesignPackageProductCardPage_ProductTliLazyQuery>;
export type DesignPackageProductCardPage_ProductTliSuspenseQueryHookResult = ReturnType<typeof useDesignPackageProductCardPage_ProductTliSuspenseQuery>;
export type DesignPackageProductCardPage_ProductTliQueryResult = Apollo.QueryResult<DesignPackageProductCardPage_ProductTliQuery, DesignPackageProductCardPage_ProductTliQueryVariables>;
export const DesignPackageProductCardPage_OptionCombinationsDocument = gql`
    query DesignPackageProductCardPage_OptionCombinations($placeholderCombinationsInput: PlaceholderCombinationsInput!, $designPackageId: ID!, $designPackageVersionId: ID!, $targetGroupIds: [ID!]) {
  designPackage(id: $designPackageId, versionId: $designPackageVersionId) {
    id
    combinations(optionGroupIds: $targetGroupIds) {
      ...DesignPackageProductCardPage_OptionCombination
    }
  }
  placeholderCombinations(input: $placeholderCombinationsInput) {
    takeoffLineItem {
      id
    }
    combinations {
      ...DesignPackageProductCardPage_OptionCombination
    }
  }
}
    ${DesignPackageProductCardPage_OptionCombinationFragmentDoc}`;

/**
 * __useDesignPackageProductCardPage_OptionCombinationsQuery__
 *
 * To run a query within a React component, call `useDesignPackageProductCardPage_OptionCombinationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDesignPackageProductCardPage_OptionCombinationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDesignPackageProductCardPage_OptionCombinationsQuery({
 *   variables: {
 *      placeholderCombinationsInput: // value for 'placeholderCombinationsInput'
 *      designPackageId: // value for 'designPackageId'
 *      designPackageVersionId: // value for 'designPackageVersionId'
 *      targetGroupIds: // value for 'targetGroupIds'
 *   },
 * });
 */
export function useDesignPackageProductCardPage_OptionCombinationsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DesignPackageProductCardPage_OptionCombinationsQuery, DesignPackageProductCardPage_OptionCombinationsQueryVariables> & ({ variables: DesignPackageProductCardPage_OptionCombinationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DesignPackageProductCardPage_OptionCombinationsQuery, DesignPackageProductCardPage_OptionCombinationsQueryVariables>(DesignPackageProductCardPage_OptionCombinationsDocument, options);
      }
export function useDesignPackageProductCardPage_OptionCombinationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DesignPackageProductCardPage_OptionCombinationsQuery, DesignPackageProductCardPage_OptionCombinationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DesignPackageProductCardPage_OptionCombinationsQuery, DesignPackageProductCardPage_OptionCombinationsQueryVariables>(DesignPackageProductCardPage_OptionCombinationsDocument, options);
        }
export function useDesignPackageProductCardPage_OptionCombinationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DesignPackageProductCardPage_OptionCombinationsQuery, DesignPackageProductCardPage_OptionCombinationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DesignPackageProductCardPage_OptionCombinationsQuery, DesignPackageProductCardPage_OptionCombinationsQueryVariables>(DesignPackageProductCardPage_OptionCombinationsDocument, options);
        }
export type DesignPackageProductCardPage_OptionCombinationsQueryHookResult = ReturnType<typeof useDesignPackageProductCardPage_OptionCombinationsQuery>;
export type DesignPackageProductCardPage_OptionCombinationsLazyQueryHookResult = ReturnType<typeof useDesignPackageProductCardPage_OptionCombinationsLazyQuery>;
export type DesignPackageProductCardPage_OptionCombinationsSuspenseQueryHookResult = ReturnType<typeof useDesignPackageProductCardPage_OptionCombinationsSuspenseQuery>;
export type DesignPackageProductCardPage_OptionCombinationsQueryResult = Apollo.QueryResult<DesignPackageProductCardPage_OptionCombinationsQuery, DesignPackageProductCardPage_OptionCombinationsQueryVariables>;
export const DesignPackageProductCardPage_SaveTakeoffLineItemDocument = gql`
    mutation DesignPackageProductCardPage_SaveTakeoffLineItem($readyPlanId: ID!, $input: [SaveTakeoffLineItemInput!]!) {
  saveTakeoffLineItems(readyPlanId: $readyPlanId, input: $input) {
    version {
      id
      readyPlan {
        id
        aggregateDraft {
          id
          version
        }
      }
    }
  }
}
    `;
export type DesignPackageProductCardPage_SaveTakeoffLineItemMutationFn = Apollo.MutationFunction<DesignPackageProductCardPage_SaveTakeoffLineItemMutation, DesignPackageProductCardPage_SaveTakeoffLineItemMutationVariables>;

/**
 * __useDesignPackageProductCardPage_SaveTakeoffLineItemMutation__
 *
 * To run a mutation, you first call `useDesignPackageProductCardPage_SaveTakeoffLineItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDesignPackageProductCardPage_SaveTakeoffLineItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [designPackageProductCardPageSaveTakeoffLineItemMutation, { data, loading, error }] = useDesignPackageProductCardPage_SaveTakeoffLineItemMutation({
 *   variables: {
 *      readyPlanId: // value for 'readyPlanId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDesignPackageProductCardPage_SaveTakeoffLineItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DesignPackageProductCardPage_SaveTakeoffLineItemMutation, DesignPackageProductCardPage_SaveTakeoffLineItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DesignPackageProductCardPage_SaveTakeoffLineItemMutation, DesignPackageProductCardPage_SaveTakeoffLineItemMutationVariables>(DesignPackageProductCardPage_SaveTakeoffLineItemDocument, options);
      }
export type DesignPackageProductCardPage_SaveTakeoffLineItemMutationHookResult = ReturnType<typeof useDesignPackageProductCardPage_SaveTakeoffLineItemMutation>;
export type DesignPackageProductCardPage_SaveTakeoffLineItemMutationResult = Apollo.MutationResult<DesignPackageProductCardPage_SaveTakeoffLineItemMutation>;
export type DesignPackageProductCardPage_SaveTakeoffLineItemMutationOptions = Apollo.BaseMutationOptions<DesignPackageProductCardPage_SaveTakeoffLineItemMutation, DesignPackageProductCardPage_SaveTakeoffLineItemMutationVariables>;